export default __webpack_public_path__ + "static/media/GARZA.1a46ba00.png";